import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  pageNumber: {
    lineHeight: '16px',
    position: 'relative',
    top: 2,
  },
  activePageNumber: {
    background: theme.palette.primary.main,
    borderRadius: 4,
    color: theme.palette.common.white,
    padding: '2px 8px 0',
    position: 'unset',
  },
  controlWrapper: {
    '& img': {
      width: 16,
    },
  },
  invertedIcon: {
    transform: 'rotate(180deg)',
    bottom: 'unset',
  },
  pageNumberInput: {
    display: 'inline-block',
    width: 18,
    marginTop: 0,
    marginBottom: 0,
    '& input': {
      padding: 0,
      textAlign: 'center',
    },
  },
  pageSizeIcon: {
    bottom: 8,
    width: 8,
  },
  wrapper: {
    // paddingLeft: theme.spacing(11),
  },
  pageSizeDropdown: {
    maxHeight: 300,
  },
  nextButton: {
    borderRadius: '50%',
    border: '1px solid rgb(249, 249, 249)',
  },
}));
